import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCrop: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconCrop"><Path d="M15 9H9V15H15V9Z" fill="currentColor"/><Path fillRule="evenodd" clipRule="evenodd" d="M7 2V5H19V17H22V19H19V22H17V19H5V7H2V5H5V2H7ZM7 17V7H17V17H7Z" fill="currentColor"/></CentralIconBase>;
});

export default IconCrop;
